<!-- 横线分隔条 组件 -->

<template>
  <div class="back-header">
    <!-- <mt-header style="background-color:#E60202;position:fixed;left:0;top:0;z-index:99999;width:100%;height:33px;">
		  <router-link to="/person" slot="left">
		    <mt-button><i class="iconfont ren" style="height:15px;color:white;"></i></mt-button>
		  </router-link>
		</mt-header> -->
    <mt-header style="background:#E60202;color:#fff;position:fixed;left:0;top:0;z-index:99999;width:100%;height:33px;">
      <router-link :to="backAddr" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  props: {
    backAddr: String
  },
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/back-header.vue